import axios from "axios";
import {
    IAddAncillariesBatchRequest,
    IAddAncillaryRequest,
    IAncillaryHistoryRecord,
    IPostSignDriverCheckResponse,
    IPostSignDriverResponse,
    IRemoveAncillariesBatchRequest,
    IRemoveAncillaryRequest
} from "../ancillary-post-sign/models";

// PATHS
const RA_DETAIL = `/network/ra/details`;
const GET_ATTACHMENT_LIST = '/network/ra/getRaDocuments';
const DOWNLOAD_ATTACHMENT = '/network/ra/getBase64';
const RA_NOTES = '/network/ra/note-list';
const RA_ADD_NOTE = '/network/ra/add-note';
const RA_CUSTOMER_REPORTS_GET_IMAGES_BY_POSITION = '/network/customer_report/{id}/images/{position}';
const RA_CUSTOMER_REPORTS_UPDATE_STATUS = '/network/customer_report/updateStatus';

// LPP-22289 / SCFE-1: vendita ancillary post-firma (proxy passthrough SC-BE, Task 10)
const RA_ANCILLARY_ADD = '/network/ancillary/add';
const RA_ANCILLARY_REMOVE = '/network/ancillary/remove';
const RA_ANCILLARY_ADD_BATCH = '/network/ancillary/add-batch';
const RA_ANCILLARY_REMOVE_BATCH = '/network/ancillary/remove-batch';
const RA_ANCILLARY_HISTORY = '/network/rental-agreement/{idRa}/ancillary-history';
// LPP-25233: guidatore aggiuntivo venduto post-firma
const RA_ANCILLARY_POST_SIGN_DRIVER = '/network/ancillary/post-sign/driver';
const RA_ANCILLARY_POST_SIGN_DRIVER_CHECK = '/network/ancillary/post-sign/driver/check';

const fetchRaDetail: any = async (req: any) => {
    const response = await axios.post(RA_DETAIL, req);
    return response.data;
}

const fetchAttachmentsInfo: any = async (req: any) => {
    const response = await axios.post(GET_ATTACHMENT_LIST, req);
    return response.data;
}

const downloadAttachment: any = async (req: any) => {
    const response = await axios.post(DOWNLOAD_ATTACHMENT, req);
    return response.data;
}

const fetchRaNotes: any = async (reqParams: {idRentalAgreement: string}) => {
    const response = await axios.get(RA_NOTES, { params: reqParams });
    return response.data;
}

const addRaNote: any = async (req: {idRentalAgreement: string, body: string}) => {
    const response = await axios.post(RA_ADD_NOTE, req);
    return response.data;
}

const getImageByPosition: any = async (id: string, position: string) => {

    console.log("getImageByPosition id:", id);
    console.log("getImageByPosition position:", position);

    const url = RA_CUSTOMER_REPORTS_GET_IMAGES_BY_POSITION
        .replace('{id}', id)
        .replace('{position}', position);

    const response = await axios.get(url);
    return response.data;
}

const updateCRStatus: any = async (req: {ra_id: string, status: string, scenario: number}) => {
    const response = await axios.post(RA_CUSTOMER_REPORTS_UPDATE_STATUS, req);
    return response.data;
}

/**
 * LPP-22289 / SCFE-1 (§2.1(7),(11)).
 * Aggiunta ancillary post-firma su RA ONGOING. Il body trasporta in passthrough le firme
 * a mano digit-sign (base64) e l'eventuale % di sconto banco verso NTW (proxy SC-BE Task 10).
 */
const addAncillaryPostSign: any = async (req: IAddAncillaryRequest) => {
    const response = await axios.post(RA_ANCILLARY_ADD, req);
    return response.data;
}

/**
 * LPP-22289 / SCFE-1 (§2.1(7),(11)).
 * Rimozione ancillary post-firma (hard-delete) da RA ONGOING; le firme digit-sign transitano
 * nel body verso NTW.
 */
const removeAncillaryPostSign: any = async (req: IRemoveAncillaryRequest) => {
    const response = await axios.post(RA_ANCILLARY_REMOVE, req);
    return response.data;
}

/**
 * LPP-22289 / SCFE-1 (§2.1(3),(4),(7)).
 * Aggiunta ATOMICA di N ancillary post-firma su RA ONGOING (multi-accessorio): una sola firma
 * digit-sign conclude l'intero blocco (tutto-o-niente lato NTW).
 */
const addAncillariesPostSignBatch: any = async (req: IAddAncillariesBatchRequest) => {
    const response = await axios.post(RA_ANCILLARY_ADD_BATCH, req);
    return response.data;
}

/**
 * LPP-22289 / SCFE-1 (§2.1(2),(3),(7)).
 * Rimozione ATOMICA di N ancillary post-firma (hard-delete) da RA ONGOING (multi-accessorio):
 * una sola firma digit-sign conclude l'intero blocco.
 */
const removeAncillariesPostSignBatch: any = async (req: IRemoveAncillariesBatchRequest) => {
    const response = await axios.post(RA_ANCILLARY_REMOVE_BATCH, req);
    return response.data;
}

/**
 * LPP-22289 / SCFE-1 (§2.1(8),(11)).
 * Storico modifiche accessori (registro delta) di un RA, alimenta la sezione "storico" del
 * dettaglio RA.
 */
const fetchAncillaryHistory: any = async (idRa: string): Promise<IAncillaryHistoryRecord[]> => {
    const url = RA_ANCILLARY_HISTORY.replace('{idRa}', encodeURIComponent(idRa));
    const response = await axios.get(url);
    return response.data;
}

/**
 * LPP-25233 (C1): registra in CB il guidatore aggiuntivo venduto post-firma. Multipart come updateDraftRA
 * dell'emissione: `driver` e' l'oggetto guidatore (JSON, tipo DRIVER), i documenti viaggiano come file.
 */
const savePostSignDriver = async (req: {
    driver: string, idRentalAgreement: string,
    idDocFront: File | null, idDocBack: File | null, drivingLicenseDocFront: File | null, drivingLicenseDocBack: File | null
}): Promise<IPostSignDriverResponse> => {
    const response = await axios.postForm(RA_ANCILLARY_POST_SIGN_DRIVER, req);
    return response.data;
}

/** LPP-25233 (C1): blacklist + patente MCTC del singolo guidatore aggiuntivo post-firma. */
const checkPostSignDriver = async (req: {idRentalAgreement: string, cbId: string}): Promise<IPostSignDriverCheckResponse> => {
    const response = await axios.post(RA_ANCILLARY_POST_SIGN_DRIVER_CHECK, req);
    return response.data;
}

export {
    fetchRaDetail,
    fetchAttachmentsInfo,
    downloadAttachment,
    fetchRaNotes,
    addRaNote,
    getImageByPosition,
    updateCRStatus,
    addAncillaryPostSign,
    removeAncillaryPostSign,
    addAncillariesPostSignBatch,
    removeAncillariesPostSignBatch,
    fetchAncillaryHistory,
    savePostSignDriver,
    checkPostSignDriver
}